<template>
  <div class="box-container">
    <div class="button-wrapper">
      <div class=" mb-3">
        <el-button-group style="margin-bottom: 4px">
          <el-button v-for="dist in distros" :key="dist" @click="selectDist(dist)"
            :type="selectedDist === dist ? 'primary' : 'default'" style="padding: 4px 10px" size="small">
            {{ dist }}
          </el-button>
          <el-tooltip class="item" effect="dark" content="仅展示当前地域已验证可创建的 Linux 公共镜像" placement="right">
            <el-button @click="fetchOthersDist" :type="showOtherSelect ? 'primary' : 'default'" size="small">
              所有发行版
            </el-button>
          </el-tooltip>
          <el-tooltip :content="kylinTooltip" placement="bottom">
            <span>
              <el-button size="small" :disabled="!kylinOffer.enabled"
                :type="selectedDist === '银河麒麟' ? 'primary' : 'default'"
                @click="selectDist('银河麒麟')">
                银河麒麟
              </el-button>
            </span>
          </el-tooltip>
        </el-button-group>
        <el-select v-if="showOtherSelect" v-model="selectedOtherDist" placeholder="选择 Linux 发行版"
          style="width: 190px; margin-left: 8px" size="small" filterable @change="selectDist">
          <el-option v-for="dist in otherDistros" :key="dist" :label="dist" :value="dist"></el-option>
        </el-select>
      </div>

      <div class="mb-3" style="
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #303133;
        ">
        <!-- Select Version -->
        <span style="margin-right: 4px">版本</span>
        <el-select v-model="selectedVersion" placeholder="Select version" :disabled="showOtherSelect"
          style="width: 120px; margin-right: 12px" size="small">
          <el-option v-for="version in versions" :key="version" :label="version" :value="version"></el-option>
        </el-select>

        <span style="margin-right: 4px">规格</span>
        <el-select v-model="selectedSpec" placeholder="Select specification" style="width: 80px; margin-right: 12px"
          size="small">
          <el-option v-for="spec in availableSpecs" :key="spec" :label="spec" :value="spec"></el-option>
        </el-select>

        <!-- High Spec Checkbox -->
        <el-checkbox v-model="highSpecChecked" @change="toggleHighSpec" style="margin-right: 10px">
          高规格
        </el-checkbox>

        <span style="margin-right: 4px; margin-left: 1rem">系统盘大小</span>
        <el-input-number v-model="systemDiskSize" :min="40" :max="1000" size="small" style="width: 100px"
          :step="10"></el-input-number>
        <span style="margin-left: 8px; color: #303133">GB</span>
      </div>

      <div class="mb-3">
        <el-form label-position="left" style="margin-top: 14px; font-weight: 900">
          <el-form-item label="实例数量">
            <el-input-number v-model="instanceCount" :min="show_apply_btn ? initialInstanceCount : 1" :max="5"
              style="width: 100px" @change="handleInstanceChange"></el-input-number>
            <span v-if="instanceChangeMessage" style="
                color: red;
                font-weight: bold;
                margin-left: 10px;
                margin-right: 10px;
              ">
              {{ instanceChangeMessage }}
            </span>
          </el-form-item>
        </el-form>
        <el-tooltip class="item" effect="dark" content="支持1-5个实例，支持逐个扩容，扩容时磁盘同步增加。" placement="bottom">
          <el-button v-if="show_apply_btn"
            :disabled="!show_apply_btn || Math.abs(initialInstanceCount - instanceCount) !== 1" type="primary"
            @click="scaleInstances" class="apply-button" size="small">
            调整实例数量
          </el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="所有实例统一释放时间，北京时间，可【延期释放】" placement="right">
          <span v-if="release_datetime !== ''" class="release-datetime" style="margin-left: 20px; color: red;">
            释放时间: {{ release_datetime }}
          </span>
        </el-tooltip>
      </div>

      <div class="mb-3 action-buttons" style="
          background-color: #e3f2fd;
          padding: 10px 20px;
          display: flex;
          justify-content: center;
          width: 100%;
        ">
        <el-tooltip class="item" effect="dark" content="批量并行创建" placement="bottom">
          <el-button type="primary" :loading="environmentRestoring || provisioning"
            :disabled="environmentRestoring || provisioning || show_apply_btn"
            @click="confirmLaunchInstances">
            {{ environmentRestoring ? "加载环境中" : provisioning ? "环境创建中" : show_apply_btn ? "环境已就绪" : "准备环境" }}
          </el-button>
          <div v-if="provisionTimerVisible" :class="['provision-timer', provisionTimerState]">
            <span class="timer-dot"></span>
            <span>{{ provisionTimerText }}</span>
            <strong>{{ formattedProvisionElapsed }}</strong>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="不再使用时，请手动释放资源，节省能源和费用" placement="bottom">
          <el-button type="danger" @click="confirmDestroyInstances">销毁环境</el-button>
        </el-tooltip>
        <span style="width: 6px"></span>
        <DelayReleaseButtonInstances @updateReleaseTime="handleUpdateReleaseTime"
          :delayReleaseButtonEnabled="delayReleaseButtonEnabled" />
        <span style="width: 6px"></span>
        <el-tooltip content="在当前实例上部署 Docker、Nginx 等练习场景" placement="bottom">
          <el-button :disabled="availableFileInstances.length === 0" @click="$router.push('/scenario-lab')">
            场景部署
          </el-button>
        </el-tooltip>
        <span style="width: 6px"></span>

        <div class="file-transfer-group">
          <el-tooltip content="查看当前环境所有实例共用的 sre 和 root 密码" placement="bottom">
            <el-button :disabled="availableFileInstances.length === 0" @click="openCredentialsDialog">
              登录凭据
            </el-button>
          </el-tooltip>
          <el-tooltip content="向一台实例上传最多10个文件" placement="bottom">
            <el-button :disabled="availableFileInstances.length === 0" @click="openUploadDialog">
              上传文件
            </el-button>
          </el-tooltip>
          <el-tooltip content="从一台实例下载一个文件" placement="bottom">
            <el-button :disabled="availableFileInstances.length === 0" @click="openDownloadDialog">
              下载文件
            </el-button>
          </el-tooltip>
        </div>

        <div class="disk-group">
          <el-tooltip class="item" effect="dark" content="为所有虚拟机添加和扩容第1块盘，最大1000GB" placement="bottom">
            <div class="button-pair group-1">
              <el-button :disabled="!diskButtonsEnabled" @click="addDisk(1)">添加磁盘1</el-button>
              <el-button :disabled="!diskButtonsEnabled" @click="expandDisk(1)">扩容</el-button>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="为所有虚拟机添加和扩容第2块盘，最大1000GB" placement="bottom">
            <div class="button-pair group-2">
              <el-button :disabled="!diskButtonsEnabled" @click="addDisk(2)">添加磁盘2</el-button>
              <el-button :disabled="!diskButtonsEnabled" @click="expandDisk(2)">扩容</el-button>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="为所有虚拟机添加和扩容第3块盘，最大1000GB" placement="bottom">
            <div class="button-pair group-3">
              <el-button :disabled="!diskButtonsEnabled" @click="addDisk(3)">添加磁盘3</el-button>
              <el-button :disabled="!diskButtonsEnabled" @click="expandDisk(3)">扩容</el-button>
            </div>
          </el-tooltip>
        </div>
      </div>

      <el-alert v-if="selectedDist === '银河麒麟'" class="kylin-notice" type="warning" :closable="false"
        show-icon title="银河麒麟 V10 SP3 是商业授权镜像">
        <template #default>
          镜像授权 {{ kylinOffer.license_points_per_instance_hour }} 积分/台/小时，ECS 计算与磁盘费用另计。
          创建前会展示完整报价；当前仅提供纯系统环境，场景模板兼容性将逐步验证。
        </template>
      </el-alert>
    </div>

    <el-dialog v-model="uploadDialogVisible" title="上传文件到实例" width="520px">
      <el-form label-width="92px">
        <el-form-item label="目标实例">
          <el-select v-model="uploadForm.instanceIndex" style="width: 100%">
            <el-option
              v-for="instance in availableFileInstances"
              :key="instance.index"
              :label="instance.label"
              :value="instance.index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="目标目录">
          <el-input v-model="uploadForm.targetDir" placeholder="/home/sre" />
          <div class="file-dialog-help">仅允许上传到 /home/sre 及其子目录</div>
        </el-form-item>
        <el-form-item label="本地文件">
          <el-upload
            v-model:file-list="uploadFiles"
            action="#"
            multiple
            :auto-upload="false"
            :limit="10"
            :on-exceed="handleUploadExceed"
          >
            <el-button type="primary">选择文件</el-button>
            <template #tip>
              <div class="file-dialog-help">支持多选，单文件最大50 MB；不会覆盖远程同名文件</div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="fileUploading" @click="submitFileUpload">
          开始上传
        </el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="downloadDialogVisible" title="从实例下载文件" width="520px">
      <el-form label-width="92px">
        <el-form-item label="来源实例">
          <el-select v-model="downloadForm.instanceIndex" style="width: 100%">
            <el-option
              v-for="instance in availableFileInstances"
              :key="instance.index"
              :label="instance.label"
              :value="instance.index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="远程文件">
          <el-input
            v-model="downloadForm.remotePath"
            placeholder="/home/sre/example.tar.gz"
          />
          <div class="file-dialog-help">请输入 /home/sre 目录内的单个文件路径</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="downloadDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="fileDownloading" @click="submitFileDownload">
          开始下载
        </el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="credentialsDialogVisible" title="登录凭据" width="500px" class="credentials-dialog">
      <div class="credentials-intro">当前环境中的所有实例共用以下登录凭据，推荐使用 sre 账户连接。</div>
      <div v-loading="credentialsLoading" class="credentials-list">
        <div class="credential-row">
          <div class="credential-account"><span>账户</span><strong>sre</strong></div>
          <div class="credential-password">
            <span>密码</span>
            <code>{{ showSrePassword ? credentials.srePassword : "••••••••••" }}</code>
          </div>
          <div class="credential-actions">
            <el-button link @click="showSrePassword = !showSrePassword">{{ showSrePassword ? "隐藏" : "显示" }}</el-button>
            <el-button link type="primary" :disabled="!credentials.srePassword" @click="copyCredential(credentials.srePassword, 'sre')">复制密码</el-button>
          </div>
        </div>
        <div class="credential-row">
          <div class="credential-account"><span>账户</span><strong>root</strong></div>
          <div class="credential-password">
            <span>密码</span>
            <code>{{ showRootPassword ? credentials.rootPassword : "••••••••••" }}</code>
          </div>
          <div class="credential-actions">
            <el-button link @click="showRootPassword = !showRootPassword">{{ showRootPassword ? "隐藏" : "显示" }}</el-button>
            <el-button link type="primary" :disabled="!credentials.rootPassword" @click="copyCredential(credentials.rootPassword, 'root')">复制密码</el-button>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="credentialsDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <div class="mb-3 mt-3" v-if="instanceCount > 0">
      <div v-for="(instance, index) in instanceCount" :key="index" class="instance-info"
        :style="{ backgroundColor: lightColors[index] }">
        <h3> 实例 {{ index + 1 }}</h3>
        <hr />
        <p>公网IP: {{ instanceInfo[`pub_ip${index + 1}`] || "" }}</p>
        <p>内部IP: {{ instanceInfo[`pri_ip${index + 1}`] || "" }}</p>
        <p>发行版: {{ selectedDist || "" }}</p>
        <p>版本号: {{ selectedVersion || "" }}</p>
        <p>规格: {{ selectedSpec || "" }}</p>
        <p>系统盘大小: {{ systemDiskSize || 40 }} GB</p>
        <p>状态: {{ instanceInfo[`status${index + 1}`] || "" }}</p>
        <div style="width: 100%">
          <p style="
              display: inline-block;
              margin-right: 6px;
              color: teal;
              margin-top: 0;
            ">
            {{ sshCommand(instanceInfo[`pub_ip${index + 1}`] || "0.0.0.0") }}
          </p>
          <el-button type="default" @click="
            copySSHCommand(instanceInfo[`pub_ip${index + 1}`] || '0.0.0.0')
            " style="display: inline-block">
            复制
          </el-button>
        </div>
        <el-button @click="
          connectInstance(
            instanceInfo[`pub_ip${index + 1}`] || '0.0.0.0',
            index
          )
          ">连接实例 {{ index + 1 }}</el-button>
      </div>
    </div>

    <!-- 添加备注输入框 -->
    <div class="mb-3">
      <el-input type="text" v-model="remark" clearable placeholder="临时备注框" maxlength="80"
        style="width: 100%;"></el-input>
    </div>

    <div class="mt-3">
      <BigTermsMacOSSimple ref="termComponent" :whost="whost" :thost="thost" :wport="wport" :port="port" :lname="lname"
        :passwd="passwd" :release_datetime="release_datetime" :termTitle="termTitle" :titleBgColor="titleBgColor"
        :borderLeftColor="borderColor" :borderRightColor="borderColor" :borderBottomColor="borderColor" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import BigTermsMacOSSimple from "./base/BigTermsMacOSSimple.vue"; // 引入新组件
import DelayReleaseButtonInstances from "./base/DelayReleaseButtonInstances.vue";
import { ElInputNumber } from "element-plus";
import { h } from 'vue';
import { clearLegacyAuth } from "../services/api";

export default {
  name: "MultiInstances",
  components: {
    BigTermsMacOSSimple, // 注册组件
    DelayReleaseButtonInstances,
    ElInputNumber,
  },
  data() {
    return {
      distros: [
        "Ubuntu",
        "Debian",
        "Rocky",
        "AlmaLinux",
        "CentOS",
        "Fedora",
        "OpenSUSE", // 更新为用户支持的发行版
      ],
      instanceChangeMessage: null, // 存储变化提示
      show_apply_btn: false,
      release_datetime: "",
      delayReleaseButtonEnabled: false,
      whost: this.getWhost(),
      wport: 8898,
      thost: "",
      port: 22,
      lname: "",
      passwd: "",
      termTitle: "",
      showReleaseTime: false,
      resId: 30066,
      versions: ["24.04", "22.04", "20.04", "18.04"],
      specs: ["1C2G", "2C2G", "2C4G", "2C8G", "4C8G", "4C16G", "4C32G"],
      highSpecChecked: false,
      instanceCount: 1, //当前实例数量
      initialInstanceCount: 1,
      previousCount: 1, // 保存上次的实例数量值
      systemDiskSize: 40,
      showOtherSelect: false,
      otherDistros: [],
      selectedDist: "Ubuntu",
      selectedOtherDist: "",
      selectedVersion: "24.04",
      kylinOffer: {
        enabled: false,
        license_points_per_instance_hour: 180,
        version: "V10 SP3-2403",
        notice: "商业镜像正在开通",
      },
      selectedSpec: "2C2G",
      previousSpec: "",
      instanceInfo: {
        pub_ip1: "",
        pub_ip2: "",
        pub_ip3: "",
        pub_ip4: "",
        pub_ip5: "",
        pri_ip1: "",
        pri_ip2: "",
        pri_ip3: "",
        pri_ip4: "",
        pri_ip5: "",
        status1: "未创建",
        status2: "未创建",
        status3: "未创建",
        status4: "未创建",
        status5: "未创建",
      },
      availableSpecs: [
        "1C2G",
        "2C2G",
        "2C4G",
        "2C8G",
        "4C8G",
        "4C16G",
        "4C32G",
      ],
      titleBgColor: "#262626", // 初始颜色
      borderColor: "#262626", // 初始边框颜色
      lightColors: ["#c8e6c9", "#7dc586", "#4fc3f7", "#ffd740", "#b0bec5"],
      termTitles: ["实例 1", "实例 2", "实例 3", "实例 4", "实例 5"],
      diskButtonsEnabled: false, // 控制磁盘按钮的可用性
      email: "", // 存储用户的电子邮件
      disk_size_1: 50, // 第1块硬盘大小
      disk_size_2: 50, // 第2块硬盘大小
      disk_size_3: 50, // 第3块硬盘大小
      remark: "", // Add this line to store the remark input
      apiHost: this.getApiHost(), // 新增 API host
      provisioning: false,
      environmentRestoring: false,
      provisionJobId: "",
      provisionPollTimer: null,
      provisionTimerId: null,
      provisionStartedAt: null,
      provisionFinishedAt: null,
      provisionElapsedSeconds: 0,
      provisionTimerState: "",
      uploadDialogVisible: false,
      downloadDialogVisible: false,
      credentialsDialogVisible: false,
      credentialsLoading: false,
      showSrePassword: false,
      showRootPassword: false,
      credentials: {
        srePassword: "",
        rootPassword: "",
      },
      uploadFiles: [],
      fileUploading: false,
      fileDownloading: false,
      uploadForm: {
        instanceIndex: 1,
        targetDir: "/home/sre",
      },
      downloadForm: {
        instanceIndex: 1,
        remotePath: "/home/sre/",
      },
    };
  },
  computed: {
    kylinTooltip() {
      if (this.kylinOffer.enabled) {
        return `可信商业镜像，授权 ${this.kylinOffer.license_points_per_instance_hour} 积分/台/小时`;
      }
      return "银河麒麟 V10 SP3 可信商业镜像正在完成云市场开通";
    },
    availableFileInstances() {
      const instances = [];
      for (let index = 1; index <= 5; index++) {
        const privateIp = this.instanceInfo[`pri_ip${index}`];
        const publicIp = this.instanceInfo[`pub_ip${index}`];
        if (privateIp || publicIp) {
          instances.push({
            index,
            label: `实例 ${index}（${publicIp || privateIp}）`,
          });
        }
      }
      return instances;
    },
    provisionTimerVisible() {
      return Boolean(this.provisionStartedAt);
    },
    provisionTimerText() {
      return {
        running: "环境准备中",
        ready: "环境已就绪",
        failed: "环境准备失败",
      }[this.provisionTimerState] || "环境准备中";
    },
    formattedProvisionElapsed() {
      const totalSeconds = Math.max(0, Math.floor(this.provisionElapsedSeconds));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
  },
  watch: {
    instanceCount(newCount, oldCount) {
      if (newCount !== oldCount) {
        // console.log(`实例数量已更改：${oldCount} -> ${newCount}`);

        if (newCount < oldCount) {
          for (let i = newCount; i < oldCount; i++) {
            delete this.instanceInfo[`pub_ip${i + 1}`];
            delete this.instanceInfo[`pri_ip${i + 1}`];
            delete this.instanceInfo[`status${i + 1}`];
          }
        }
      }
    },

    // 监听 instanceInfo 中任何实例的变化
    instanceInfo: {
      handler(newInfo) {
        console.log("Instance info updated:", newInfo);

        // 检查每个实例的状态并触发相关操作
        for (let i = 1; i <= this.instanceCount; i++) {
          if (newInfo[`status${i}`] === "已创建") {
            console.log(`实例 ${i} 已创建`);
          } else if (newInfo[`status${i}`] === "已存在") {
            console.log(`实例 ${i} 已存在`);
          }
        }
      },
      deep: true, // 深度监听，监控对象内部的变化
    },
  },
  beforeUnmount() {
    if (this.provisionPollTimer) {
      clearTimeout(this.provisionPollTimer);
    }
    if (this.provisionTimerId) {
      clearInterval(this.provisionTimerId);
    }
  },
  mounted() {
    this.loadCurrentEnvironment();
    this.loadOsCatalog();
  },
  methods: {
    async openCredentialsDialog() {
      this.credentialsDialogVisible = true;
      if (this.credentials.srePassword && this.credentials.rootPassword) return;
      this.credentialsLoading = true;
      try {
        const response = await axios.get("/api/multi_instance_credentials");
        this.credentials.srePassword = response.data?.sre?.password || "";
        this.credentials.rootPassword = response.data?.root?.password || "";
      } catch (error) {
        this.credentialsDialogVisible = false;
        ElMessage.error(error?.response?.data?.message || "登录凭据加载失败");
      } finally {
        this.credentialsLoading = false;
      }
    },
    async copyCredential(password, account) {
      if (!password) return;
      try {
        await navigator.clipboard.writeText(password);
        ElMessage.success(`${account} 密码已复制`);
      } catch (error) {
        ElMessage.error("复制失败，请手动选择密码复制");
      }
    },
    async loadOsCatalog() {
      try {
        const response = await axios.get("/api/multi_instances_os_catalog", {
          _skipAuthRedirect: true,
        });
        const offer = response.data?.items?.find(
          (item) => item.name === "银河麒麟"
        );
        if (offer) this.kylinOffer = offer;
      } catch (error) {
        if (error.response?.status !== 401) {
          console.warn("加载操作系统目录失败:", error);
        }
      }
    },
    async loadCurrentEnvironment() {
      this.environmentRestoring = true;
      try {
        const response = await axios.get("/api/active_multi_instances", {
          params: { task_id: this.resId },
          _skipAuthRedirect: true,
        });
        const data = response.data || {};
        if (data.status === "READY" && data.active_task) {
          this.restoreActiveEnvironment(data.active_task);
          localStorage.removeItem("multiInstancesProvisionJob");
          return;
        }
        if (["QUEUED", "RUNNING"].includes(data.status) && data.job_id) {
          const payload = data.request || {};
          this.provisioning = true;
          this.provisionJobId = data.job_id;
          this.startProvisionTimer(data.created_at);
          this.rememberProvisionJob(payload, data.created_at);
          this.pollProvisionJob(payload);
          return;
        }
        this.restoreProvisionJob();
      } catch (error) {
        if (error.response?.status !== 401) {
          console.warn("加载现有环境失败，尝试恢复本地任务:", error);
          this.restoreProvisionJob();
        }
      } finally {
        this.environmentRestoring = false;
      }
    },
    restoreActiveEnvironment(task) {
      const instances = Array.isArray(task.instances) ? task.instances : [];
      for (let index = 1; index <= 5; index++) {
        const instance = instances[index - 1];
        this.instanceInfo[`pub_ip${index}`] = instance?.public_ipv4 || "";
        this.instanceInfo[`pri_ip${index}`] = instance?.inner_ipv4 || "";
        this.instanceInfo[`status${index}`] = instance ? "已创建" : "未创建";
      }
      this.instanceCount = Math.max(1, instances.length);
      this.initialInstanceCount = this.instanceCount;
      this.previousCount = this.instanceCount;
      this.passwd = task.passwd || "";
      this.release_datetime = task.release_datetime || "";
      this.port = task.port || 22;
      this.whost = task.whost || this.getWhost();
      this.wport = task.wport || 8898;
      this.lname = task.username || "sre";
      this.show_apply_btn = instances.length > 0;
      this.showReleaseTime = instances.length > 0;
      this.delayReleaseButtonEnabled = instances.length > 0;
      this.diskButtonsEnabled = instances.length > 0;

      const profile = task.profile || {};
      if (profile.selectedDist) this.selectedDist = profile.selectedDist;
      if (profile.selectedVersion) this.selectedVersion = profile.selectedVersion;
      if (profile.selectedSpec) this.selectedSpec = profile.selectedSpec;
      if (profile.systemDiskSize) this.systemDiskSize = Number(profile.systemDiskSize);
    },
    selectDefaultFileInstance() {
      const first = this.availableFileInstances[0];
      return first ? first.index : null;
    },
    openUploadDialog() {
      this.uploadForm.instanceIndex = this.selectDefaultFileInstance();
      this.uploadForm.targetDir = "/home/sre";
      this.uploadFiles = [];
      this.uploadDialogVisible = true;
    },
    openDownloadDialog() {
      this.downloadForm.instanceIndex = this.selectDefaultFileInstance();
      this.downloadForm.remotePath = "/home/sre/";
      this.downloadDialogVisible = true;
    },
    handleUploadExceed() {
      ElMessage.warning("单次最多选择10个文件");
    },
    async submitFileUpload() {
      if (!this.uploadForm.instanceIndex || this.uploadFiles.length === 0) {
        ElMessage.warning("请选择目标实例和需要上传的文件");
        return;
      }
      const oversized = this.uploadFiles.find(
        item => Number(item.raw?.size || item.size || 0) > 50 * 1024 * 1024
      );
      if (oversized) {
        ElMessage.warning(`${oversized.name} 超过50 MB限制`);
        return;
      }
      const formData = new FormData();
      formData.append("task_id", String(this.resId));
      formData.append("instance_index", String(this.uploadForm.instanceIndex));
      formData.append("target_dir", this.uploadForm.targetDir || "/home/sre");
      this.uploadFiles.forEach(item => formData.append("files", item.raw));
      this.fileUploading = true;
      try {
        const response = await axios.post("/api/instance_files/upload", formData);
        ElMessage.success(response.data.message || "文件上传成功");
        this.uploadDialogVisible = false;
        this.uploadFiles = [];
      } catch (error) {
        ElMessage.error(error.response?.data?.message || "文件上传失败");
      } finally {
        this.fileUploading = false;
      }
    },
    async submitFileDownload() {
      if (!this.downloadForm.instanceIndex || !this.downloadForm.remotePath.trim()) {
        ElMessage.warning("请选择来源实例并填写远程文件路径");
        return;
      }
      this.fileDownloading = true;
      try {
        const response = await axios.get("/api/instance_files/download", {
          params: {
            task_id: this.resId,
            instance_index: this.downloadForm.instanceIndex,
            remote_path: this.downloadForm.remotePath.trim(),
          },
          responseType: "blob",
        });
        const disposition = response.headers["content-disposition"] || "";
        const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
        const fallbackName = this.downloadForm.remotePath.split("/").pop() || "download";
        const filename = encodedName ? decodeURIComponent(encodedName) : fallbackName;
        const objectUrl = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
        this.downloadDialogVisible = false;
        ElMessage.success("文件下载已开始");
      } catch (error) {
        let message = "文件下载失败";
        if (error.response?.data instanceof Blob) {
          try {
            const data = JSON.parse(await error.response.data.text());
            message = data.message || message;
          } catch (_) {
            // Keep the generic message when the response is not JSON.
          }
        }
        ElMessage.error(message);
      } finally {
        this.fileDownloading = false;
      }
    },
    startProvisionTimer(createdAt) {
      const serverStartedAt = Number(createdAt) * 1000;
      this.provisionStartedAt = Number.isFinite(serverStartedAt) && serverStartedAt > 0
        ? serverStartedAt
        : Date.now();
      this.provisionFinishedAt = null;
      this.provisionTimerState = "running";
      this.updateProvisionElapsed();
      if (this.provisionTimerId) {
        clearInterval(this.provisionTimerId);
      }
      this.provisionTimerId = setInterval(this.updateProvisionElapsed, 250);
    },
    updateProvisionElapsed() {
      if (!this.provisionStartedAt) return;
      const endAt = this.provisionFinishedAt || Date.now();
      this.provisionElapsedSeconds = Math.max(
        0,
        (endAt - this.provisionStartedAt) / 1000
      );
    },
    finishProvisionTimer(state, finishedAt) {
      const serverFinishedAt = Number(finishedAt) * 1000;
      this.provisionFinishedAt = Number.isFinite(serverFinishedAt) && serverFinishedAt > 0
        ? serverFinishedAt
        : Date.now();
      this.provisionTimerState = state;
      this.updateProvisionElapsed();
      if (this.provisionTimerId) {
        clearInterval(this.provisionTimerId);
        this.provisionTimerId = null;
      }
      localStorage.removeItem("multiInstancesProvisionJob");
    },
    rememberProvisionJob(payload, createdAt) {
      localStorage.setItem("multiInstancesProvisionJob", JSON.stringify({
        jobId: this.provisionJobId,
        payload,
        createdAt,
        email: localStorage.getItem("email") || "",
      }));
    },
    restoreProvisionJob() {
      try {
        const saved = JSON.parse(
          localStorage.getItem("multiInstancesProvisionJob") || "null"
        );
        if (
          !saved?.jobId ||
          !saved?.payload ||
          saved.email !== (localStorage.getItem("email") || "")
        ) {
          return;
        }
        this.provisioning = true;
        this.provisionJobId = saved.jobId;
        this.startProvisionTimer(saved.createdAt);
        this.pollProvisionJob(saved.payload);
      } catch (error) {
        console.warn("恢复环境创建计时失败:", error);
        localStorage.removeItem("multiInstancesProvisionJob");
      }
    },
    getWhost() {
      const hostname = window.location.hostname;

      // 中国站点
      if (hostname === 'sre.azlinux.com' || hostname === 'cn.sre.azlinux.com') {
        return 'sre.azlinux.com';
      }

      // 香港站点
      if (hostname === 'hk.sre.azlinux.com' || hostname === 'hk.azlinux.com') {
        return 'hk.azlinux.com';
      }
      return 'sre.azlinux.com';
    },
    getApiHost() {
      const hostname = window.location.hostname;
      if (hostname === 'hk.sre.azlinux.com' || hostname === 'hk.azlinux.com') {
        return 'hk.azlinux.com';
      }
      return 'sre.azlinux.com';
    },
    async scaleInstances() {
      console.log("开始执行 scaleInstances() 函数 - 增加实例数量");

      // Check if the current instance count is the same as the previous count
      if (this.instanceCount === this.previousCount) {
        ElMessage({
          message: `调整无效。实例数量无变化(${this.instanceCount}个): 请通过【+】增加，或【-】减少实例数量`,
          type: "error",
          duration: 5000,
          offset: 240,
        });
        return; // Exit the method if there is no change
      }

      // Assuming newCount is defined and holds the new instance count
      const message = `扩容中，磁盘数量和大小也会同步，数量变化: ${this.initialInstanceCount}个 -> ${this.instanceCount}个`; // Correctly use template literals
      ElMessage({
        message: message,
        type: "success",
        duration: 5000,
        offset: 240,
      });

      let email = localStorage.getItem("email");
      let email_user;

      // 检查用户登录状态
      if (email) {
        email_user = email.substring(4);
        console.log(`[扩容]已获取邮箱信息，处理后的用户标识: ${email_user}`);
      } else {
        email_user = "";
        console.warn("[扩容]未检测到登录邮箱，请先登录！");
        ElMessage({
          message: "检测到您尚未登录，请登录后使用，3秒后自动跳转到登录页面",
          type: "error",
          duration: 3000,
          offset: 240,
        });

        // 添加倒计时跳转逻辑
        let countdown = 3;
        const interval = setInterval(() => {
          countdown--;
          if (countdown > 0) {
            ElMessage({
              message: `即将跳转，倒计时 ${countdown} 秒`,
              type: "info",
              duration: 1000,
              offset: 240,
            });
          } else {
            clearInterval(interval);
            window.location.href = "/login";
          }
        }, 1000);

        return;
      }

      // 检查实例数量是否有效
      if (
        !this.instanceCount ||
        isNaN(this.instanceCount) ||
        this.instanceCount < 1 ||
        this.instanceCount > 5
      ) {
        console.error(`[扩容] 实例数量无效: ${this.instanceCount}`);
        ElMessage({
          message: "实例数量无效，请输入 1 到 5 之间的数字。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      } else {
        console.log(`[扩容] 实例数量有效: ${this.instanceCount}`);
      }

      // 检查系统磁盘大小是否有效
      if (
        !this.systemDiskSize ||
        isNaN(this.systemDiskSize) ||
        this.systemDiskSize < 40 ||
        this.systemDiskSize > 1000
      ) {
        console.error(`[扩容] 系统盘大小无效: ${this.systemDiskSize}`);
        ElMessage({
          message: "系统磁盘大小无效，请输入 40 到 1000 之间的数字。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      } else {
        console.log(`[扩容] 系统磁盘大小有效: ${this.systemDiskSize}`);
      }

      const payload = {
        instanceCount: parseInt(this.instanceCount), // 确保是数值
        systemDiskSize: parseInt(this.systemDiskSize), // 确保是数值
        selectedDist: this.selectedDist,
        selectedVersion: this.selectedVersion,
        selectedSpec: this.selectedSpec,
        email: email_user,
        id: this.resId,
      };

      console.log("[扩容] 构建的请求 payload:", payload);
      this.showReleaseTime = true;

      try {
        console.log("[扩容] 发送请求到服务器...");
        const response = await axios.post(
          `/api/scale_instances`,
          payload
        );
        console.log("[扩容] 服务器响应数据:", response.data);

        if (
          response.data.status_code === 200 &&
          Array.isArray(response.data.data?.instances) &&
          response.data.data.instances.length === payload.instanceCount
        ) {
          console.log("[扩容] 扩容成功，开始更新 instanceInfo");

          this.show_apply_btn = true;
          this.instanceChangeMessage = null; // clear the change message

          response.data.data.instances.forEach((instance, index) => {
            this.instanceInfo[`pub_ip${index + 1}`] = instance.public_ipv4;
            this.instanceInfo[`pri_ip${index + 1}`] = instance.inner_ipv4;
            this.instanceInfo[`status${index + 1}`] = "已创建";
            console.log(`实例 ${index + 1} 信息已更新:`, {
              pub_ip: instance.public_ipv4,
              pri_ip: instance.inner_ipv4,
              zone_id: instance.zone_id,
              status: "已创建",
            });
          });

          this.passwd = response.data.data.passwd;
          this.release_datetime = response.data.data.release_datetime;
          this.port = response.data.data.port;
          this.whost = response.data.data.whost;
          this.wport = response.data.data.wport;
          this.lname = response.data.data.username;

          console.log("连接参数已更新:", {
            passwd: this.passwd,
            port: this.port,
            whost: this.whost,
            wport: this.wport,
            lname: this.lname
          });

          this.instanceCount = response.data.data.instances.length;
          this.initialInstanceCount = this.instanceCount;

          // 成功后显示启动成功的提示
          ElMessage({
            message: "实例扩容成功！同规格大小磁盘已同步创建。",
            type: "success",
            duration: 5000,
            offset: 240,
          });
        } else {
          console.warn("实例扩容失败");
          ElMessage({
            message: "实例扩容失败，请重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      } catch (error) {
        console.error("扩容后启动实例时出错:", error);

        if (error.response) {
          const { status, data } = error.response;
          console.warn(`HTTP 错误状态码: ${status}`, "错误响应内容:", data);

          if (status === 409) {
            if (data.job_id) {
              this.provisioning = true;
              this.provisionJobId = data.job_id;
              this.pollProvisionJob(payload);
              return;
            }
            ElMessage({
              message: data.error || "用户已经存在多实例任务，请稍后再试。",
              type: "error",
              duration: 3000,
              offset: 240,
            });

            // 即使是409错误，也设置必要的连接信息
            if (data.active_task) {
              this.show_apply_btn = true;
              this.release_datetime = data.active_task.release_datetime;
              this.delayReleaseButtonEnabled = true;
              this.passwd = data.active_task.passwd;  // 设置密码
              this.diskButtonsEnabled = true; // 启用磁盘按钮

              if (data.active_task.instances) {
                console.log("已存在的实例信息:", data.active_task.instances);

                this.instanceCount = data.active_task.instances.length;
                this.initialInstanceCount = this.instanceCount;

                data.active_task.instances.forEach((instance, index) => {
                  this.instanceInfo[`pub_ip${index + 1}`] = instance.public_ipv4;
                  this.instanceInfo[`pri_ip${index + 1}`] = instance.inner_ipv4;
                  this.instanceInfo[`status${index + 1}`] = "已存在";
                  console.log(`实例 ${index + 1} 已存在，状态更新:`, {
                    pub_ip: instance.public_ipv4,
                    pri_ip: instance.inner_ipv4,
                    zone_id: instance.zone_id,
                    status: "已存在",
                  });
                });

                // 打印连接参数以便调试
                console.log("连接参数已更新:", {
                  passwd: this.passwd,
                  release_datetime: this.release_datetime
                });
              }
            }
          } else {
            ElMessage({
              message: `请求失败，请检查网络或重试。错误代码：${status}`,
              type: "error",
              duration: 3000,
              offset: 240,
            });
          }
        } else {
          console.error("请求没有响应，可能是网络或服务器故障。");
          ElMessage({
            message: "网络错误，请检查连接。可能是服务器故障。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      }
    },
    handleInstanceChange(newCount) {
      if (this.show_apply_btn) {  // 已经创建了实例
        if (newCount < this.initialInstanceCount) {
          // 如果用户试图减少实例数量
          ElMessage({
            message: "您可以 poweroff 对应的虚拟机即可达到减少实例数量的目的",
            type: "warning",
            duration: 3000,
            offset: 240,
          });
          // 恢复到原来的实例数量
          this.instanceCount = this.initialInstanceCount;
        } else {
          // 只在增加数量时才显示变化消息
          this.instanceChangeMessage = `${this.initialInstanceCount} -> ${newCount}`;
        }
      } else {
        // 在创建实例之前，允许自由调整数量
        this.instanceChangeMessage = null;
      }
    },
    setTitleColor(index) {
      // 更新 titleBgColor 为 lightColors 中对应的颜色
      this.titleBgColor = this.lightColors[index % this.lightColors.length];
    },
    handleUpdateReleaseTime(newReleaseTime) {
      this.release_datetime = newReleaseTime;
      console.log("New release time after delay: ", newReleaseTime);
    },
    handleDelayReleaseSuccess() {
      console.log("Delay release success.");
    },
    selectDist(dist) {
      this.selectedDist = dist;
      this.showOtherSelect = false;
      if (dist === "Ubuntu") {
        this.versions = ["24.04", "22.04", "20.04", "18.04"];
        this.selectedVersion = "24.04";
      } else if (dist === "Debian") {
        this.versions = ["12"];
        this.selectedVersion = "12";
      } else if (dist === "Rocky") {
        this.versions = ["9"];
        this.selectedVersion = "9";
      } else if (dist === "AlmaLinux") {
        this.versions = ["9"];
        this.selectedVersion = "9";
      } else if (dist === "CentOS") {
        this.versions = ["stream_9", "stream_8", "7.9", "6.10"];
        this.selectedVersion = "stream_9";
      } else if (dist === "Fedora") {
        this.versions = ["40"];
        this.selectedVersion = "40";
      } else if (dist === "OpenSUSE") {
        this.versions = ["15.6"];
        this.selectedVersion = "15.6";
      } else if (dist === "Alibaba Cloud Linux") {
        this.versions = ["4", "3"];
        this.selectedVersion = "4";
      } else if (dist === "Anolis OS") {
        this.versions = ["8.10", "8.9"];
        this.selectedVersion = "8.10";
      } else if (dist === "银河麒麟") {
        this.versions = ["V10 SP3-2403"];
        this.selectedVersion = "V10 SP3-2403";
      }
    },
    fetchOthersDist() {
      this.showOtherSelect = true;
      this.selectedOtherDist = "";
      this.otherDistros = [
        "Alibaba Cloud Linux",
        "Anolis OS",
      ];
    },
    async confirmLaunchInstances() {
      try {
        // The HttpOnly session cookie is authoritative. localStorage.email is
        // only legacy display/cache data and may survive after a session ends.
        const sessionResponse = await axios.get("/api/session", {
          _skipAuthRedirect: true,
        });
        const sessionEmail = String(sessionResponse.data?.email || "").trim();
        if (!sessionEmail) {
          const authError = new Error("AUTH_REQUIRED");
          authError.isAuthRequired = true;
          throw authError;
        }
        localStorage.setItem("email", `sre-${sessionEmail}`);
      } catch (error) {
        if (error.response?.status === 401 || error.isAuthRequired) {
          await this.showLoginRequired();
          return;
        }
        ElMessage({
          message: error.response?.data?.message || "暂时无法验证登录状态，请稍后重试",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      try {
        const quoteResponse = await axios.post("/api/multi_instances_quote", {
          instanceCount: parseInt(this.instanceCount),
          systemDiskSize: parseInt(this.systemDiskSize),
          selectedSpec: this.selectedSpec,
          selectedDist: this.selectedDist,
          selectedVersion: this.selectedVersion,
        }, {
          _skipAuthRedirect: true,
        });
        const quote = quoteResponse.data;
        if (quote.os_offer?.commercial && !quote.os_offer.enabled) {
          ElMessageBox.alert(
            "银河麒麟商业镜像正在完成云市场开通，暂时无法创建。其他 Linux 发行版不受影响。",
            "商业镜像暂未开放",
            { confirmButtonText: "知道了", type: "warning" }
          );
          return;
        }
        if (!quote.can_create) {
          ElMessageBox.alert(
            `本次需要预冻结 ${quote.reserve_points} 积分，当前可用 ${quote.available_points} 积分，请先充值。`,
            "积分不足",
            { confirmButtonText: "知道了", type: "warning" }
          );
          return;
        }
        const memberBenefit = quote.vip_startup_free
          ? "会员免启动服务费；"
          : `启动服务费 ${quote.startup_fee_points} 积分；`;
        const licenseText = quote.image_license_points_per_hour > 0
          ? `商业镜像授权 ${quote.image_license_points_per_hour} 积分/小时；`
          : "";
        const resourcePoints = Number(quote.compute_points_per_hour)
          + Number(quote.disk_points_per_hour);
        const billingText = `${memberBenefit}计算与磁盘 ${resourcePoints.toFixed(2)} 积分/小时；${licenseText}合计 ${quote.points_per_hour} 积分/小时，创建时预冻结 ${quote.reserve_points} 积分。`;
        await ElMessageBox.confirm(
        `您将创建 ${this.instanceCount} 台虚拟机。${billingText} 是否继续？`,
        "确认创建",
        {
          confirmButtonText: "继续创建",
          cancelButtonText: "取消",
          type: "warning",
          distinguishCancelAndClose: true,
        }
        );
        this.launchInstances();
      } catch (error) {
        if (error === "cancel" || error === "close") {
          return;
        }
        if (error.response?.status === 401) {
          await this.showLoginRequired();
          return;
        }
        ElMessage({
          message: error.response?.data?.message
            || error.response?.data?.error
            || "暂时无法获取资源报价",
          type: "error",
          duration: 3000,
          offset: 240,
        });
      }
    },
    async showLoginRequired() {
      clearLegacyAuth();
      localStorage.removeItem("multiInstancesProvisionJob");
      try {
        await ElMessageBox.confirm(
          "当前登录状态已失效，请重新登录后创建练习环境。",
          "请重新登录",
          {
            confirmButtonText: "前往登录",
            cancelButtonText: "稍后再说",
            type: "warning",
          }
        );
        this.$router.push("/login");
      } catch (action) {
        // 用户选择稍后登录时留在当前页面。
      }
    },
    async launchInstances() {
      console.log("开始执行 launchInstances() 函数 - 准备环境");

      let email = localStorage.getItem("email");
      let email_user;

      if (!email) {
        //   console.error("Email is not defined or is null.");
        console.warn("未检测到登录邮箱，请先登录！");
        ElMessage({
          message: "检测到您尚未登录，请登录后使用，3秒后自动跳转到登录页面",
          type: "error",
          duration: 3000,
          offset: 240,
        });

        // 添加倒计时跳转逻辑
        let countdown = 3;
        const interval = setInterval(() => {
          countdown--;
          if (countdown > 0) {
            ElMessage({
              message: `即将跳转，倒计时 ${countdown} 秒`,
              type: "info",
              duration: 1000,
              offset: 240,
            });
          } else {
            clearInterval(interval);
            window.location.href = "/login";
          }
        }, 1000);

        return;
      } else if (email.length < 5) {
        // console.warn("Email is too short to extract user identifier.");
        ElMessage({
          message: "请点击【个人中心】，登录您的账号。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      // 检查用户登录状态
      if (email) {
        email_user = email.substring(4);
        console.log(`已获取邮箱信息，处理后的用户标识: ${email_user}`);
      } else {
        email_user = "";
        console.warn("未检测到登录邮箱，请先登录！");
        ElMessage({
          message: "检测到您尚未登录，请登录后使用，3秒后自动跳转到登录页面",
          type: "error",
          duration: 3000,
          offset: 240,
        });

        // 添加倒计时跳转逻辑
        let countdown = 3;
        const interval = setInterval(() => {
          countdown--;
          if (countdown > 0) {
            ElMessage({
              message: `即将跳转，倒计时 ${countdown} 秒`,
              type: "info",
              duration: 1000,
              offset: 240,
            });
          } else {
            clearInterval(interval);
            window.location.href = "/login";
          }
        }, 1000);

        return;
      }

      // 检查实例数量是否有效
      if (
        !this.instanceCount ||
        isNaN(this.instanceCount) ||
        this.instanceCount < 1 ||
        this.instanceCount > 5
      ) {
        console.error(`实例数量无效: ${this.instanceCount}`);
        ElMessage({
          message: "实例数量无效，请输入 1 到 5 之间的数字。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      } else {
        console.log(`实例数量有效: ${this.instanceCount}`);
      }

      // 检查系统磁盘大小是否有效
      if (
        !this.systemDiskSize ||
        isNaN(this.systemDiskSize) ||
        this.systemDiskSize < 40 ||
        this.systemDiskSize > 1000
      ) {
        console.error(`系统盘大小无效: ${this.systemDiskSize}`);
        ElMessage({
          message: "系统磁盘大小无效，请输入 40 到 1000 之间的数字。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      } else {
        console.log(`系统磁盘大小有效: ${this.systemDiskSize}`);
      }

      ElMessage({
        message: "实例启动中，请稍候...",
        type: "success",
        duration: 5000,
        offset: 240,
      });

      const payload = {
        instanceCount: parseInt(this.instanceCount), // 确保是数值
        systemDiskSize: parseInt(this.systemDiskSize), // 确保是数值
        selectedDist: this.selectedDist,
        selectedVersion: this.selectedVersion,
        selectedSpec: this.selectedSpec,
        email: email_user,
        id: this.resId,
      };

      console.log("构建的请求 payload:", payload);
      this.showReleaseTime = true;

      try {
        console.log("发送请求到服务器...");
        const response = await axios.post(
          `/api/create_multi_instances`,
          payload
        );
        console.log("服务器响应数据:", response.data);
        console.log("服务器响应数据:", response.data.vip_status);

        if (response.status === 202 && response.data.job_id) {
          this.provisioning = true;
          this.provisionJobId = response.data.job_id;
          this.startProvisionTimer(response.data.created_at);
          this.rememberProvisionJob(payload, response.data.created_at);
          for (let index = 1; index <= payload.instanceCount; index++) {
            this.instanceInfo[`status${index}`] = "排队创建中";
          }
          ElMessage({
            message: "创建任务已进入队列，页面会自动更新进度",
            type: "success",
            duration: 3000,
            offset: 240,
          });
          this.pollProvisionJob(payload);
          return;
        }

        // Add VIP status check
        if (response.data.vip_status === 0) {
          ElMessageBox.confirm(
            '您的VIP状态已过期，是否前往购买会员卡？',
            '会员过期提醒',
            {
              confirmButtonText: '立即购买',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            // 用户点击"立即购买"，跳转到购买页面
            this.$router.push('/buy-vip');
          }).catch(() => {
            // 用户点击取消，只显示提示消息
            ElMessage({
              message: "您可以稍后在个人中心购买会员卡",
              type: "info",
              duration: 3000,
              offset: 240,
            });
          });
          return;
        }

        if (response.data.status_code === 200) {
          this.applyProvisionResult(response.data.data, payload);
        } else {
          console.warn("实例启动失败，响应数据不完整");
          ElMessage({
            message: response.data.message || "实例创建结果不完整，请稍后重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      } catch (error) {
        console.error("启动实例时出错:", error);

        if (error.response) {
          const { status, data } = error.response;
          console.warn(`HTTP 错误状态码: ${status}`, "错误响应内容:", data);

          if (status === 409) {
            if (data.job_id) {
              this.provisioning = true;
              this.provisionJobId = data.job_id;
              this.startProvisionTimer(data.created_at);
              this.rememberProvisionJob(payload, data.created_at);
              this.pollProvisionJob(payload);
              return;
            }
            ElMessage({
              message: data.error || "用户已经存在多实例任务，请稍后再试。",
              type: "error",
              duration: 3000,
              offset: 240,
            });

            // 即使是409错误，也设置必要的连接信息
            if (data.active_task) {
              this.show_apply_btn = true;
              this.release_datetime = data.active_task.release_datetime;
              this.delayReleaseButtonEnabled = true;
              this.passwd = data.active_task.passwd;  // 设置密码
              this.diskButtonsEnabled = true; // 启用磁盘按钮

              if (data.active_task.instances) {
                console.log("已存在的实例信息:", data.active_task.instances);

                this.instanceCount = data.active_task.instances.length;
                this.initialInstanceCount = this.instanceCount;

                data.active_task.instances.forEach((instance, index) => {
                  this.instanceInfo[`pub_ip${index + 1}`] = instance.public_ipv4;
                  this.instanceInfo[`pri_ip${index + 1}`] = instance.inner_ipv4;
                  this.instanceInfo[`status${index + 1}`] = "已存在";
                  console.log(`实例 ${index + 1} 已存在，状态更新:`, {
                    pub_ip: instance.public_ipv4,
                    pri_ip: instance.inner_ipv4,
                    zone_id: instance.zone_id,
                    status: "已存在",
                  });
                });

                // 打印连接参数以便调试
                console.log("连接参数已更新:", {
                  passwd: this.passwd,
                  release_datetime: this.release_datetime
                });
              }
            }
          } else {
            ElMessage({
              message: data.message || `请求失败，请稍后重试。错误代码：${status}`,
              type: "error",
              duration: 3000,
              offset: 240,
            });
          }
        } else {
          console.error("请求没有响应，可能是网络或服务器故障。");
          ElMessage({
            message: "网络错误，请检查连接。可能是服务器故障。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      }
    },
    pollProvisionJob(payload) {
      if (!this.provisionJobId) return;
      axios.get(`/api/multi_instance_jobs/${this.provisionJobId}`)
        .then((response) => {
          const job = response.data;
          if (job.status === "READY" && job.data) {
            this.provisioning = false;
            this.provisionJobId = "";
            this.finishProvisionTimer("ready", job.finished_at);
            this.applyProvisionResult(job.data, payload);
            return;
          }
          if (job.status === "FAILED") {
            this.provisioning = false;
            this.provisionJobId = "";
            this.finishProvisionTimer("failed", job.finished_at);
            for (let index = 1; index <= payload.instanceCount; index++) {
              this.instanceInfo[`status${index}`] = "创建失败";
            }
            ElMessage({
              message: job.message || "实例创建失败，请稍后重试",
              type: "error",
              duration: 5000,
              offset: 240,
            });
            return;
          }
          const text = job.status === "RUNNING" ? "云资源初始化中" : "排队创建中";
          for (let index = 1; index <= payload.instanceCount; index++) {
            this.instanceInfo[`status${index}`] = text;
          }
          this.provisionPollTimer = setTimeout(
            () => this.pollProvisionJob(payload),
            1500
          );
        })
        .catch((error) => {
          console.error("查询创建任务失败:", error);
          this.provisionPollTimer = setTimeout(
            () => this.pollProvisionJob(payload),
            3000
          );
        });
    },
    applyProvisionResult(data, payload) {
      if (
        !Array.isArray(data.instances) ||
        data.instances.length !== payload.instanceCount
      ) {
        this.provisioning = false;
        this.finishProvisionTimer("failed");
        ElMessage.error("云平台返回的实例数量不完整，请稍后重试");
        return;
      }
      this.show_apply_btn = true;
      data.instances.forEach((instance, index) => {
        this.instanceInfo[`pub_ip${index + 1}`] = instance.public_ipv4;
        this.instanceInfo[`pri_ip${index + 1}`] = instance.inner_ipv4;
        this.instanceInfo[`status${index + 1}`] = "已创建";
      });
      this.passwd = data.passwd;
      this.release_datetime = data.release_datetime;
      this.port = data.port;
      this.whost = data.whost;
      this.wport = data.wport;
      this.lname = data.username;
      this.delayReleaseButtonEnabled = true;
      this.instanceCount = data.instances.length;
      this.initialInstanceCount = this.instanceCount;
      this.diskButtonsEnabled = true;
      this.provisioning = false;
      ElMessage({
        message: "实例创建成功，可以开始连接。",
        type: "success",
        duration: 3000,
        offset: 240,
      });
    },
    confirmDestroyInstances() {
      // 弹出确认对话框
      ElMessageBox.confirm(
        `您将销毁 ${this.instanceCount} 台虚拟机，是否继续？`,
        "确认销毁",
        {
          confirmButtonText: "继续销毁",
          cancelButtonText: "取消",
          type: "warning",
          confirmButtonClass: 'el-button--danger', // 确认按钮的颜色与销毁按钮相同
        }
      )
        .then(() => {
          // 用户点击继续销毁，调用真正的请求
          this.destroyInstances();
        })
        .catch(() => {
          // 用户点击取消，什么都不做
          console.log("用户取消了销毁虚拟机");
        });
    },
    async destroyInstances() {
      console.log("准备销毁环境");

      // 获取 email 并进行校验
      let email = localStorage.getItem("email");
      let email_user;

      if (email) {
        email_user = email.substring(4);
      } else {
        email_user = "";
        ElMessage({
          message: "请登录您的账号，【个人中心】",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      this.showReleaseTime = false;

      ElMessage({
        message: "已启动销毁流程，耗时1分钟以内，您可以进行其他操作。",
        type: "success",
        duration: 3000,
        offset: 240,
      });

      // 重置状态到初始值
      this.resetInstanceInfo();

      // 设置 payload 数据，包含 email、delete_security_code 和 id
      const payload = {
        email: email_user,
        delete_security_code: "sre_alinux_c0m",
        id: this.resId,
      };

      try {
        const response = await axios.delete(
          `/api/delete_multi_instances`,
          {
            data: payload,
          }
        );

        if (response.status === 200) {
          console.log("环境销毁成功");
          ElMessage({
            message: "环境已成功销毁",
            type: "success",
            duration: 3000,
            offset: 240,
          });
        } else {
          ElMessage({
            message: "环境销毁失败，请重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      } catch (error) {
        console.error("销毁环境时出错:", error);

        // 检查错误响应状态码
        if (error.response) {
          const { status, data } = error.response;
          if (status === 404) {
            ElMessage({
              message: "您没有要删除的多实例资源，无需【销毁环境】",
              type: "warning",
              duration: 3000,
              offset: 240,
            });
          } else if (status === 409) {
            ElMessage({
              message: data.error || "环境销毁冲突，已有其他活动任务。",
              type: "error",
              duration: 3000,
              offset: 240,
            });
          } else {
            ElMessage({
              message: `请求失败，请检查网络或重试。错误代码：${status}`,
              type: "error",
              duration: 3000,
              offset: 240,
            });
          }
        } else {
          ElMessage({
            message: "网络错误，请检查连接。可能是服务器故障。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      }
    },
    resetInstanceInfo() {
      // 重置状态到初始值的逻辑
      this.instanceInfo = {
        pub_ip1: "",
        pub_ip2: "",
        pub_ip3: "",
        pub_ip4: "",
        pub_ip5: "",
        pri_ip1: "",
        pri_ip2: "",
        pri_ip3: "",
        pri_ip4: "",
        pri_ip5: "",
        status1: "未创建",
        status2: "未创建",
        status3: "未创建",
        status4: "未创建",
        status5: "未创建",
      };
      this.passwd = ""; // 清空密码
      this.credentials = { srePassword: "", rootPassword: "" };
      this.showSrePassword = false;
      this.showRootPassword = false;
      this.credentialsDialogVisible = false;
      this.release_datetime = ""; // 清空释放时间
      this.instanceCount = 1; // 恢复实例数量
      this.initialInstanceCount = 1; // 恢复初始实例数量
      this.show_apply_btn = false; // 隐藏应用按钮
      this.instanceChangeMessage = null; // 清空实例变化消息
      this.highSpecChecked = false; // 恢复高规格复选框状态
      this.selectedSpec = "2C2G"; // 恢复默认规格
      this.selectedVersion = "24.04"; // 恢复默认版本
      this.selectedDist = "Ubuntu"; // 恢复默认发行版
    },
    delayRelease() {
      console.log("延迟释放");
      // 这里添加你的逻辑
    },
    async addDisk(diskNumber) {
      const diskLabel = diskNumber === 1 ? '添加第 1 块磁盘' :
        diskNumber === 2 ? '添加第 2 块磁盘' :
          '添加第 3 块磁盘';

      // 设置默认的磁盘大小为100
      let diskSize = 100; // 默认值为100

      try {
        await ElMessageBox({
          title: diskLabel,
          message: h('div', {}, [
            h('span', {}, '磁盘大小 (40-1000) GB'),
            // 使用原生input元素来接收数字输入
            h('input', {
              type: 'number',
              value: diskSize, // 初始值为100
              min: 40,
              max: 1000,
              step: 1,
              style: {
                width: '140px',
                marginLeft: '10px'
              },
              onInput: (event) => {
                diskSize = Number(event.target.value); // 更新 diskSize
              }
            }),
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              done(); // 直接关闭对话框，因为值已经被自动调整到有效范围内
            } else {
              done(); // 取消时直接关闭
            }
          },
        });
      } catch (error) {
        if (error === 'cancel') {
          console.log("用户取消了添加磁盘");
          return; // 返回避免后续逻辑
        }
        console.error("弹出对话框时出错:", error);
        return;
      }

      let email = localStorage.getItem("email");
      let email_user;

      if (email) {
        email_user = email.substring(4);
      } else {
        ElMessage({
          message: "请登录您的账号，【个人中心】",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      console.log("准备发送请求，参数如下：");
      console.log("Email:", email_user);
      console.log("Disk Size:", diskSize);
      console.log("Disk Number:", diskNumber);

      const apiUrl = `/api/instances_attach_disk${diskNumber}`;
      try {
        const response = await axios.post(apiUrl, {
          email: email_user,
          diskSize: diskSize,
          diskNo: diskNumber,
        });

        if (response.status === 200) {
          ElMessage({
            message: `所有实例成功添加磁盘${diskNumber}，大小为${diskSize}GB`,
            type: "success",
            duration: 3000,
            offset: 240,
          });
        } else {
          // 显示后端返回的错误信息
          ElMessage({
            message: response.data.message || "添加磁盘失败，请重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      } catch (error) {
        console.error("添加磁盘时出错:", error);

        // 处理后端返回的错误消息
        if (error.response && error.response.data && error.response.data.message) {
          ElMessage({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
            offset: 240,
          });
        } else {
          ElMessage({
            message: "请求失败，请检查网络或重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      }
    }
    ,
    async expandDisk(diskNumber) {
      console.log("扩容磁盘函数调用，传入的 diskNumber:", diskNumber);

      // 根据磁盘编号设置扩容提示标签
      const diskLabel = diskNumber === 1 ? '扩容第 1 块磁盘' :
        diskNumber === 2 ? '扩容第 2 块磁盘' :
          '扩容第 3 块磁盘';

      let currentDiskSize = 0; // 用于存储从接口查询到的磁盘当前容量
      let newDiskSize = 0; // 扩容 new disk size

      // 从 localStorage 获取用户的 email
      let email = localStorage.getItem("email");
      let email_user;

      // 如果没有登录，提示用户登录
      if (email) {
        email_user = email.substring(4); // 假设 email 格式是 'user_XXXX'
      } else {
        ElMessage({
          message: "请登录您的账号，【个人中心】",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      // 获取磁盘当前容量的接口
      const queryApiUrl = `/api/get_disk_size_${diskNumber}`;

      console.log("获取磁盘当前容量...");
      try {
        // 调用接口获取磁盘当前容量
        const queryResponse = await axios.post(queryApiUrl, {
          email: email_user, // 后端接口需要传递 email 参数
          disk_no: diskNumber, // 确保参数名为 disk_no，符合后端接口的定义
        });

        // 检查响应数据是否有效
        if (queryResponse.status === 200 && queryResponse.data) {
          currentDiskSize = queryResponse.data[`disk_size_${diskNumber}`]; // 动态提取磁盘当前容量
          newDiskSize = Math.floor(Math.min(currentDiskSize + 100, 1000)); // 确保 newDiskSize 为整数

        } else {
          ElMessage({
            message: "获取磁盘当前容量失败，请稍后重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
          return;
        }
      } catch (error) {
        console.error("获取磁盘当前容量时出错:", error);
        ElMessage({
          message: "请求失败，无法获取磁盘当前容量。",
          type: "error",
          duration: 3000,
          offset: 240,
        });
        return;
      }

      console.log(`磁盘当前容量为 ${currentDiskSize} GB`);

      try {
        // 弹出对话框让用户输入扩容后的磁盘大小
        await ElMessageBox({
          title: diskLabel,
          message: h('div', {}, [
            h('span', {}, `磁盘当前容量 ${currentDiskSize} GB`),
            h('input', {
              type: 'number',
              value: newDiskSize,
              min: currentDiskSize + 1, // 扩容大小必须大于当前容量
              max: 1000,
              step: 1,
              style: {
                width: '140px',
                marginLeft: '10px'
              },
              onInput: (event) => {
                newDiskSize = Number(event.target.value); // 更新输入值
              }
            }),
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              done();
            } else {
              done();
            }
          },
        });
      } catch (error) {
        if (error === 'cancel') {
          console.log("用户取消了扩容磁盘");
          return;
        }
        console.error("弹出对话框时出错:", error);
        return;
      }

      console.log("准备发送请求，参数如下：");
      console.log("Email:", email_user);
      console.log("New Disk Size:", newDiskSize);
      console.log("Disk Number:", diskNumber);

      const apiUrl = `/api/expand_disk_${diskNumber}`;

      try {
        // 发送扩容请求
        const response = await axios.post(apiUrl, {
          email: email_user,
          diskNo: diskNumber,
          diskNewSize: newDiskSize,
        });

        // 根据响应结果处理
        if (response.status === 200) {
          ElMessage({
            message: `所有实例成功扩容磁盘${diskNumber}，新容量为${newDiskSize}GB`,
            type: "success",
            duration: 3000,
            offset: 240,
          });
        } else {
          ElMessage({
            message: response.data.message || "扩容磁盘失败，请重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      } catch (error) {
        console.error("扩容磁盘时出错:", error);

        // 如果后端返回了错误消息，展示它
        if (error.response && error.response.data && error.response.data.message) {
          ElMessage({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
            offset: 240,
          });
        } else {
          ElMessage({
            message: "请求失败，请检查网络或重试。",
            type: "error",
            duration: 3000,
            offset: 240,
          });
        }
      }
    }

    ,
    toggleHighSpec() {
      if (this.highSpecChecked) {
        // 保存当前选中的规格
        this.previousSpec = this.selectedSpec;

        // 切换到高规格
        this.availableSpecs = ["8C16G", "8C32G"];
        this.selectedSpec = "8C16G"; // 默认选择高规格
      } else {
        // 恢复到之前保存的规格
        this.availableSpecs = this.specs;
        this.selectedSpec = this.previousSpec;
      }
    },
    sshCommand(ip) {
      return `ssh sre@${ip}`;
    },
    async copySSHCommand(ip) {
      if (ip === '0.0.0.0') {
        this.$message({
          message: "该实例尚未创建，请点击【准备环境】或【调整实例数量】",
          type: "error",
          offset: 240,
        });
        return;
      }

      const sshCmd = this.sshCommand(ip);

      if (!sshCmd) {
        this.$message({
          message: "无法生成 SSH 命令，请检查实例状态。",
          type: "error",
          offset: 240,
        });
        return;
      }

      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(sshCmd);
          this.$message({
            message: `SSH 连接命令已复制: ${sshCmd}`,
            type: "success",
            duration: 3000,
            offset: 240,
          });
        } catch (err) {
          this.$message({
            message: "复制命令失败，请手动复制。",
            type: "error",
            offset: 240,
          });
          console.error('复制失败:', err);
        }
      } else {
        this.$message({
          message: "当前运行模式【http】不支持复制功能，请手动复制命令。",
          type: "error",
          offset: 240,
        });
      }
    },
    connectInstance(ip, index) {
      // 获取内网IP
      const internalIp = this.instanceInfo[`pri_ip${index + 1}`];

      if (ip === "0.0.0.0" || !internalIp) {
        this.$message({
          message: "实例尚未创建，无法连接。请点击【准备环境】",
          type: "error",
          offset: 240,
        });
        return;
      }

      // 检查密码是否存在
      if (!this.passwd) {
        this.$message({
          message: "连接密码未设置，请先准备环境",
          type: "error",
          offset: 240,
        });
        return;
      }

      // 设置所有必要的连接参数
      this.thost = internalIp;  // 使用内网IP而不是公网IP
      this.lname = "sre";

      // 设置颜色和标题
      const selectedColor = this.lightColors[index];
      this.titleBgColor = selectedColor;
      this.borderColor = selectedColor;  // 设置边框颜色
      this.termTitle = this.termTitles[index];

      // console.log("Connecting with params:", {
      //   thost: this.thost,        // 这里会显示内网IP
      //   whost: this.whost,
      //   wport: this.wport,
      //   port: this.port,
      //   lname: this.lname,
      //   passwd: this.passwd
      // });

      // 调用子组件的 connectBox 方法
      this.$nextTick(() => {
        if (this.$refs.termComponent) {
          this.$refs.termComponent.connectBox();
        }
      });

      this.$message({
        message: `连接实例${index + 1}: ${internalIp}`,  // 更简洁的消息
        type: "success",
        duration: 2000,  // 缩短显示时间到2秒
        offset: 260,
      });
    },
  },
};
</script>

<style scoped>
.box-container {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-button {
  padding: 2px 6px;
}

.mb-3 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.ml-2 {
  margin-left: 16px;
}

.mt-3 {
  margin-top: 16px;
}

.instance-info {
  padding: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 13px;
  text-align: left;
  min-width: 144px;
}

h3 {
  font-weight: 400;
  font-style: italic;
}

.release-datetime {
  font-size: 15px;
  color: #555;
  margin-left: 6px;
}

.loading-spinner {
  text-align: center;
  font-size: 18px;
}

.button-pair {
  display: inline-flex;
  padding: 4px;
  border-radius: 4px;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.disk-group {
  display: flex;
  gap: 12px;
  /* Add some space between disk groups */
  margin-left: 16px;
  /* Adjust as needed for horizontal alignment */
}

.group-1 {
  background-color: #f8bbd0;
  /* Light Pink */
}

.group-2 {
  background-color: #f48fb1;
  /* Soft Orange */
}

.group-3 {
  background-color: #f06292;
  /* Light Yellow */
}


.apply-button {
  margin-left: 10px;
}

.file-transfer-group {
  display: inline-flex;
  gap: 4px;
  margin-right: 12px;
  padding: 4px;
  background: #e8f5e9;
  border-radius: 4px;
}

.file-dialog-help {
  width: 100%;
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.credentials-intro {
  margin-bottom: 14px;
  padding: 10px 12px;
  color: #526273;
  background: #f5f9ff;
  border: 1px solid #dce9f8;
  border-radius: 8px;
  line-height: 1.5;
}

.credentials-list {
  min-height: 150px;
}

.credential-row {
  display: grid;
  grid-template-columns: 80px minmax(180px, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid #edf0f5;
}

.credential-row:last-child {
  border-bottom: 0;
}

.credential-account span,
.credential-password span {
  display: block;
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
}

.credential-account strong {
  font-size: 16px;
}

.credential-password code {
  color: #1f2d3d;
  font-size: 15px;
  word-break: break-all;
}

.credential-actions {
  white-space: nowrap;
}

@media (max-width: 600px) {
  .credential-row {
    grid-template-columns: 64px 1fr;
  }

  .credential-actions {
    grid-column: 2;
  }
}

.provision-timer {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 154px;
  margin-left: 10px;
  padding: 6px 10px;
  color: #1769aa;
  background: #ffffff;
  border: 1px solid #90caf9;
  border-radius: 6px;
  font-variant-numeric: tabular-nums;
}

.provision-timer strong {
  margin-left: auto;
  font-size: 16px;
}

.timer-dot {
  width: 8px;
  height: 8px;
  background: #409eff;
  border-radius: 50%;
}

.provision-timer.running .timer-dot {
  animation: timer-pulse 1.2s ease-in-out infinite;
}

.provision-timer.ready {
  color: #277a3c;
  border-color: #8bd39c;
  background: #f0f9eb;
}

.provision-timer.ready .timer-dot {
  background: #34a853;
}

.provision-timer.failed {
  color: #b42318;
  border-color: #f0a6a0;
  background: #fef0f0;
}

.provision-timer.failed .timer-dot {
  background: #e53935;
}

@keyframes timer-pulse {
  0%,
  100% {
    opacity: 0.35;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}
</style>
